
<button (click)="goBack()" class="btn btn-sm btn-primary"><i class="fas fa-arrow-left"></i>Back to Results</button>

<learnable-detail></learnable-detail>
